import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api/blogs`;
const API_URL_ADMIN = `${process.env.REACT_APP_BACKEND_URL}/api/admin/blogs`;

const authHeaders = () => {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Public
export const getBlogs = () => axios.get(API_URL);
export const getBlog = (id) => axios.get(`${API_URL}/${id}`);

// Admin (requires Bearer token)
export const getBlogs_Admin = () => axios.get(API_URL_ADMIN, { headers: authHeaders() });
export const getBlog_Admin = (id) => axios.get(`${API_URL_ADMIN}/${id}`, { headers: authHeaders() });
export const createBlog_Admin = (blog) => axios.post(API_URL_ADMIN, blog, { headers: authHeaders() });
export const updateBlog_Admin = (id, blog) => axios.put(`${API_URL_ADMIN}/${id}`, blog, { headers: authHeaders() });
export const deleteBlog_Admin = (id) => axios.delete(`${API_URL_ADMIN}/${id}`, { headers: authHeaders() });
